import { FC, MouseEvent } from "react";
import { toShort2 } from "../../utils/common.util.ts";
import { Position } from "../../enums/position.enum.ts";
import Tooltip from "../tooltip/tooltip.component.tsx";
import { RiSendPlaneFill } from "react-icons/ri";

type CallbackComponentType = {
  callbackUrl: string | null;
  shortFirst?: number;
  shortLast?: number;
  disabledSep?: boolean;
  position?: Position;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

const CallbackComponent: FC<CallbackComponentType> = ({
  callbackUrl,
  shortFirst,
  shortLast,
  disabledSep,
  position,
  onClick,
}) => {
  return (
    <>
      <div className="flex items-center">
        <Tooltip
          className="whitespace-nowrap"
          title="URL"
          message={callbackUrl || "Not set"}
          position={position}
        >
          <span className="font-medium text-slate-700 text-right">
            {toShort2(callbackUrl, shortFirst, shortLast, disabledSep) ||
              "Not set"}
          </span>
        </Tooltip>
        <Tooltip
          className="whitespace-nowrap"
          title="Action"
          message={"Send" + " " + "callback"}
          position={position}
        >
          <button
            className="btn btn-xs flex p-1.5 justify-center bg-transparent shadow-none! text-indigo-500 font-bold transition-all active:scale-95"
            onClick={onClick}
          >
            <RiSendPlaneFill
              className="text-indigo-500 cursor-pointer"
              size={18}
            />
          </button>
        </Tooltip>
      </div>
    </>
  );
};

export default CallbackComponent;
